export const CppRecruitingStatuses = {
    UNDECIDED: 1,
    ACTIVE: 2,
    COMMITTED: 3,
};

export const STATUS_LABELS = {
    [CppRecruitingStatuses.UNDECIDED]: 'Undecided',
    [CppRecruitingStatuses.ACTIVE]: 'Active',
    [CppRecruitingStatuses.COMMITTED]: 'Committed',
};

// Shown when the player has no recruiting-status row (statusId is null) — a null status
// is a distinct state from an affirmatively-chosen Undecided and must not display as one.
export const EMPTY_STATUS_TEXT = 'NA';

export const STATUS_OPTIONS = [
    {
        id: CppRecruitingStatuses.UNDECIDED,
        label: 'Undecided',
        description: 'Exploring my options and still figuring out my college goals.',
    },
    {
        id: CppRecruitingStatuses.ACTIVE,
        label: 'Active',
        description: 'Currently contacting coaches and evaluating programs to find a fit.',
    },
    {
        id: CppRecruitingStatuses.COMMITTED,
        label: 'Committed',
        description: 'I have officially committed to a college tennis program.',
    },
];

export const RECRUITING_STATUS_ENDPOINT = '/v1/cpp/recruiting-status';
